import React, { useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typo, useLazyLoadImage } from 'tmt-ui-kit';
import moment from 'moment-timezone';

import { inverseCountryMap, countryFlagPath } from '~/utils/countries';
import { path, defaultAvatarImage } from '~/utils/media';

moment.tz.setDefault('Asia/Bangkok');

const TravelerContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 16px;
`;

const TravelerDetailContainer = styled.div`
  padding-left: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const TravelerName = styled(Typo.HeaderFive)`
  margin-bottom: 8px !important;
  margin-top: 0px !important;
`;

const TravelerCountryRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    margin-right: 7px;
    height: 12px;
    &[src=''] {
      display: none;
    }
    @media(max-width: 700px) {
      margin-right: 5px;
      height: 10px;
    }
  }
  @media(min-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const CountryContainer = styled.div`
  display: flex;
  align-items: center;
  img[src=''] {
    display: none;
  }
`;

const DesktopHide = styled.span`
  @media(min-width: 700px) {
    display: none;
  }
`;

const BarText = styled(Typo.Paragraph)`
  margin: 0 4px !important;
`;

const ReviewDate = styled(Typo.Paragraph)`
  display: flex;
  margin: 0px !important;
`;

const AvatarContainer = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CountryTitle = styled(Typo.Paragraph)`
  margin: 0;
`;

const Avatar = styled.img`
  width: 100%;
`;

const ReviewTraveler = ({ traveler, createdAt }) => {
  const avatarRef = useRef();
  const countryRef = useRef();
  useLazyLoadImage(avatarRef);
  useLazyLoadImage(countryRef);
  const avatar = traveler.avatar_image
    ? path(traveler.avatar_image, 'avatarReviewCard')
    : defaultAvatarImage(traveler.name.first);
  const largeAvatar = traveler.avatar_image
    ? path(traveler.avatar_image, 'avatarReviewCard2x')
    : defaultAvatarImage(traveler.name.first, true);
  const { last_country: country } = traveler;
  const countryCode = inverseCountryMap[country] ? inverseCountryMap[country] : '';
  const flagPath = countryFlagPath(countryCode);
  const flagPathRetina = countryFlagPath(countryCode, true);
  return (
    <TravelerContainer>
      <AvatarContainer>
        <Avatar ref={avatarRef} data-src={avatar} data-srcset={`${largeAvatar}`} />
      </AvatarContainer>
      <TravelerDetailContainer>
        <TravelerName>{traveler.name && `${traveler.name.first} ${traveler.name.last}`}</TravelerName>
        <TravelerCountryRow>
          {country && countryCode && (
            <CountryContainer>
              <img
                ref={countryRef}
                data-src={flagPath}
                data-srcset={`${flagPathRetina}`}
                alt={country}
              />
              <CountryTitle>{country}</CountryTitle>
              <DesktopHide><BarText>|</BarText></DesktopHide>
            </CountryContainer>
          )}
          <ReviewDate>{moment(createdAt).format('LL')}</ReviewDate>
        </TravelerCountryRow>
      </TravelerDetailContainer>
    </TravelerContainer>
  );
};

ReviewTraveler.propTypes = {
  traveler: PropTypes.object,
  createdAt: PropTypes.string,
};

export default ReviewTraveler;
